import React from "react";
import "./Infrastructure.css"

function Infrastructure() {
  return (
    <div className="infra-main">
      <div className="infrap">
        <p className="p">Infrastructure</p>
        <div className="p2">
      {/* <p>Swajit Engineering Pvt.Ltd: > Infrastructure</p> */}
      </div>
        </div>
    </div>
  );
}

export default Infrastructure;
